import { locationType } from '../types/priceTypes';

export const getLocationCoordinates = async (
  options?: PositionOptions
): Promise<locationType | null> => {
  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({
            lat: latitude,
            long: longitude,
          });
        },
        (error) => {
          resolve(null);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
          ...options,
        }
      );
    } else {
      resolve(null);
    }
  });
};
